var Handlebars = require('handlebars');

(function () {
    if (window.location.pathname != '/locations') return;

    var GMaps = require('gmaps');

    $('.slideshow').PikaChoose({
        showCaption: false,
        autoPlay: false,
    });

    var scrollAnchor = $('#scroll-anchor').val();

    if (scrollAnchor) {
        var hash = '#' + scrollAnchor;
        var $target = $(hash);

        if (!$target.position()) return;

        $(this).addClass('selected');

        $('.locations-container').scrollTop($target.position().top);
    }

    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();

        var target = this.hash,
            $target = $(target);

        if (!$target.position()) return;

        $('.selected').removeClass('selected');
        $(this).addClass('selected');

        //('.locations-container').stop().animate({
        //    scrollTop: $target.position().top
        //}, 900, 'swing', function() {
        window.location.hash = target;
        //});
    });

    var latitude = $('#latitude').val() || 0;
    var longitude = $('#longitude').val() || 0;
    var zoom = $('#zoom').val() || 2;

    var map = new GMaps({
        el: '#gmap',
        lat: latitude,
        lng: longitude,
        zoom: parseInt(zoom),
        minZoom: 2,
    });

    $.get('/api/locations', function (data) {
        var bounds = new google.maps.LatLngBounds();
        var fitBounds = false;

        $.get('/templates/locations/map_marker.html', function (html) {
            var template = Handlebars.compile(html);
            var markers = [];

            $.each(data, function (index, location) {
                if (location.latitude == 0 && location.longitude == 0) {
                    return true;
                }

                var arrayKey = location.latitude + '_' + location.longitude;

                // Join Harlow and Standsted into one marker (blame GMUK for this)
                if (location.id === 16 || location.id === 136) {
                    arrayKey = 'standsted';
                }

                if (!(arrayKey in markers)) {
                    markers[arrayKey] = [];
                }

                markers[arrayKey].push(location);
            });

            $.each(Object.keys(markers), function (index, key) {
                var markerData = markers[key];

                var marker = map.addMarker({
                    lat: markerData[0].latitude,
                    lng: markerData[0].longitude,
                    title: markerData[0].name,
                    icon: '/images/map-pin.png',
                    infoWindow: {
                        content: template({ locations: markerData }),
                    },
                });

                bounds.extend(marker.getPosition());

                fitBounds = true;
            });

            if (fitBounds && latitude === 0 && longitude === 0) {
                map.fitBounds(bounds);
                map.fitZoom();
            }
        });
    });
})();
